import { useSetRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { referralApi } from "api/referralApi";
import { userApi } from "api/userApi";
import { captureException } from "utils/sentry";

/**
 * 레퍼럴 코드를 로그인된 유저에 영속화하고, 유저 정보를 다시 받아 반영한다.
 *
 * 서버는 referralCodeType 을 "저장된 레퍼럴 코드" 기준으로 계산하므로(UserBO.simpleUser),
 * 저장 직전에 받은 로그인 응답에는 이번 코드가 반영되어 있지 않다. 갱신하지 않으면
 * 결과 화면이 낡은 값으로 안내 문구를 고른다.
 *
 * 저장·갱신 실패는 로그인/이동 흐름을 막지 않는다 (로그만 남기고 reject 하지 않는다).
 * 대신 저장 성공 여부를 반환하므로, 재시도가 필요한 호출부는 이 값으로 판단한다.
 */
export default function useSaveReferralCode() {
  const setUser = useSetRecoilState(userSimpleAtom);

  return async (code: string): Promise<boolean> => {
    try {
      await referralApi.saveReferralCode(code);
    } catch (e) {
      captureException(e, { tags: { action: "affiliate_referral_save" } });
      return false;
    }

    try {
      const response = await userApi.getSimplePromotion();
      if (response.code === 0 && response.result) {
        // accessToken 은 응답에 없으므로 기존 값을 유지한다.
        setUser((prev) => ({ ...prev, ...response.result }));
      }
    } catch (e) {
      captureException(e, {
        tags: { action: "affiliate_referral_user_refresh" },
      });
    }

    return true;
  };
}
